import { memo } from 'react';
import { useLink } from 'hoofd';
import type { LinkOptions } from 'hoofd';

export const MetaLink = memo((props: LinkOptions) => {
    useLink(props);
    return null;
});
